import { memo } from 'react'

import * as Styled from './styled'

interface IProps {
  minValue?: number
  maxValue?: number
  step?: number
  value?: number
  isFullWidth?: boolean
  className?: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleMouseUp?: (value: number) => void
}

const RangeSlider: React.FC<IProps> = props => {
  const {
    onChange,
    handleMouseUp,
    maxValue = 100,
    minValue = 0,
    value = 0,
    step = 1,
    className = '',
    isFullWidth = false
  } = props

  const onMouseUp = () => {
    if (handleMouseUp) {
      handleMouseUp(value)
    }
  }

  return (
    <Styled.Wrapper $isFullWidth={isFullWidth} className={className}>
      <Styled.RangeSliderWrapper value={value} min={minValue} max={maxValue}>
        <Styled.RangeSlider
          type="range"
          onChange={onChange}
          value={value}
          min={minValue}
          max={maxValue}
          step={step}
          onMouseUp={onMouseUp}
          onTouchEnd={onMouseUp}
        />
      </Styled.RangeSliderWrapper>
    </Styled.Wrapper>
  )
}

export default memo(RangeSlider)
